import React from "react";
import { motion } from "framer-motion";

const ExpButton = ({
  index,
  experience,
  activeExperience,
  setActiveExperience,
}) => {
  const setActive = () => {
    setActiveExperience(index);
  };

  const backgroundColor =
    activeExperience === index
      ? "var(--activeBackground)"
      : "var(--sdBackground)";

  const experienceClassName =
    " text-xl rounded-md px-8 py-6 min-w-full flex flex-col justify-between overflow-hidden transition-all duration-400";

  return (
    <motion.div
      className={experienceClassName}
      style={{ backgroundColor }} // Apply background color dynamically here
      onClick={setActive}
    >
      <div>{experience.positionName}</div>
      <div className="flex justify-between mt-6">
        <div>{experience.start}</div>
        <div>{experience.end}</div>
      </div>
    </motion.div>
  );
};

export default ExpButton;
